import type { HTTPError } from '@ixigo/fetch';
import type { AppContext } from '@/utils';

function logoutPwa() {
	if (window.webkit?.messageHandlers?.callbackHandler) {
		window.webkit.messageHandlers.callbackHandler.postMessage({
			logout: 'logoutUser',
		});
	} else if (
		window.IxiWebView &&
		typeof window.IxiWebView.logoutUser === 'function'
	) {
		window.IxiWebView.logoutUser();
	}
}

/**
 *
 * @param httpError - The HTTP error object thrown by `@ixigo/fetch`
 * @param appContext - The app context
 * @returns The HTTP error object
 * @description Handles the unauthorized error by clearing the cookies and logging out the user
 */
export function handleUnauthorizedError(
	httpError: HTTPError,
	appContext: Pick<AppContext, 'cookie'>,
) {
	// TODO: these utilities should be moved to login library to not depend on the internal like cookie name and localStorage key
	// we should also figure out why do we need to reload the page after logout rather than invalidating the authentication state
	// by emitting an event
	const response = httpError.response;
	const status = response.status;
	if (status === 401 && !response.url.includes('/api/v2/oauth/logout')) {
		const cookies = ['at', 'lt'];
		cookies.forEach((cookie) => {
			appContext.cookie.clearCookie(cookie);
		});
		localStorage.removeItem('userInfo');
		logoutPwa();
		window.location.reload();
	}
	return httpError;
}

/**
 * a temporary utility to check if the user is logged in
 * once login library exposes some imperative utility to check if the user is logged in, we should remove this utility
 */
export function isLoggedIn(appContext: AppContext) {
	return !!appContext.clientConfig().at;
}
